/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                // affix menu
                $(function () {
                    var stickyTop = $('.header__main').offset().top;

                    $(document).scroll(function () {
                        if ($(document).scrollTop() >= stickyTop) {
                            $('.header__main').addClass('fixed');
                        } else {
                            $('.header__main').removeClass('fixed');
                        }
                    });
                });

                // menuIcon
                $(".menu-icon").click(function () {
                    $(this).toggleClass("active");
                    $(".navigation").toggleClass("active");
                });

                // Submenu
                $(".menu-item-has-children").click(function () {
                    $(this).children().toggleClass("active");
                });


                $(document).on("click", "#play-video", function () {
                    $(this).parent().parent().remove();
                });


                $('.icon__slider').owlCarousel({
                    loop: false,
                    margin: 15,
                    nav: false,
                    responsive: {
                        0: {
                            nav: false,
                            dots: true,
                            slideBy: 1,
                            items: 1
                        },
                        400: {
                            nav: false,
                            dots: true,
                            slideBy: 2,
                            items: 2
                        },
                        1000: {
                            nav: true,
                            dots: true,
                            slideBy: 4,
                            items: 4
                        }
                    }
                });

                $('.accessoires__slider').owlCarousel({
                    loop: false,
                    margin: 15,
                    nav: false,
                    responsive: {
                        0: {
                            nav: false,
                            dots: true,
                            slideBy: 1,
                            items: 1
                        },
                        400: {
                            nav: false,
                            dots: true,
                            slideBy: 2,
                            items: 2
                        },
                        1000: {
                            nav: true,
                            dots: true,
                            slideBy: 4,
                            items: 4
                        }
                    }
                });

                $('.images__block--small').owlCarousel({
                    loop: false,
                    margin: 10,
                    nav: false,
                    dots: false,
                    responsive: {
                        0: {
                            items: 3,
                            slideBy: 3,
                            nav: false
                        },
                        600: {
                            items: 4,
                            slideBy: 4,
                            nav: false
                        },
                        1000: {
                            items: 5,
                            slideBy: 5,
                            nav: true
                        }
                    }
                });

                $('.products__slider').owlCarousel({
                    loop: false,
                    margin: 15,
                    nav: false,
                    dots: false,
                    responsive: {
                        0: {
                            margin: 15,
                            stagePadding: 15,
                            nav: true,
                            slideBy: 1,
                            items: 1
                        },
                        480: {
                            margin: 15,
                            stagePadding: 15,
                            nav: true,
                            slideBy: 1,
                            items: 1
                        },
                        544: {
                            nav: true,
                            slideBy: 2,
                            items: 2
                        },
                        1000: {
                            nav: true,
                            slideBy: 3,
                            items: 3
                        }
                    }
                });

                $('.hero .slider').owlCarousel({
                    loop: true,
                    margin: 0,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: false
                        },
                        544: {
                            items: 1,
                            nav: true,
                            dots: true
                        }
                    }
                });
                $(".owl-prev").html('');
                $(".owl-next").html('');

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

document.addEventListener('DOMContentLoaded', function () {

    // document.documentElement.setAttribute('lang', 'nl-BE');

    function addUrlToLanguageswitcher() {

        //Create LI element and add to WPML language switcher
        let nodeLi = document.createElement('li');
        nodeLi.id = 'dropdown-li-custom';
        document.getElementById("dropdown-wpml-menu").appendChild(nodeLi);

        //Create A element and add to newly created LI
        let nodeLink = document.createElement('a');
        nodeLink.id = 'dropdown-link-custom';
        nodeLink.href = 'https://www.thomas-aspirateur.fr/';
        let link = document.createTextNode('Frans');
        nodeLink.appendChild(link);
        document.getElementById("dropdown-li-custom").appendChild(nodeLink);


        //Create IMG element and add to newly created link
        let nodeImage = document.createElement('img');
        nodeImage.className = 'dropdown-image-custom';
        nodeImage.src = 'https://www.thomas-stofzuigers.nl/app/plugins/sitepress-multilingual-cms/res/flags/fr.png';
        document.getElementById("dropdown-link-custom").appendChild(nodeImage);

        //Place link text after IMG
        nodeLink.appendChild(link);

    }

    function checkLanguage() {
        let language = document.documentElement.lang;
        return language === 'nl-BE';
    }

    // console.log(checkLanguage());
    if(checkLanguage() === true) {
        addUrlToLanguageswitcher();
    }

}, false);

